import { downloadFileFromUrl } from './download-file';
import type { ReportFormat } from '../types/report.types';

export function buildReportFilename(title: string, format: ReportFormat, dateLabel?: string): string {
  const ext = format === 'excel' ? 'xlsx' : format;
  const safeTitle = title.replace(/\//g, '-').trim();
  if (dateLabel) {
    return `${safeTitle} ${dateLabel.replace(/\//g, '-')}.${ext}`;
  }
  return `${safeTitle}.${ext}`;
}

export async function downloadGeneratedReport(
  downloadUrl: string,
  title: string,
  format: ReportFormat,
  dateLabel?: string
): Promise<void> {
  const filename = buildReportFilename(title, format, dateLabel);
  await downloadFileFromUrl(downloadUrl, filename);
}
